// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"453ddccf","239":"642e3074","732":"fb592978"}[chunkId] + ".chunk.js";
};